module.exports = __webpack_public_path__ + "static/img/register.474523a1.png";